module.exports = __webpack_public_path__ + "img/01zs.e24d053a.png";